import { Routes } from 'react-router-dom'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { QUAN_LY_GIAO_VIEC_SHORT_PREFIX_URL } from './constants/config.quan-ly-giao-viec'
import mapRouterHelper from '../../utils/MapRouterHelper'
import ProjectRouters from './modules/project/Project.Routers'
import AdminGiaoViecRouters from './modules/admin-giao-viec/AdminGiaoViec.Routers'
import TaskFileCategoryRouters from './modules/task-file-category/TaskFileCategory.Routers'
import TaskTagRouters from './modules/task-tag/TaskTagRouters'
import CustomFieldRouters from './modules/custom-field/CustomField.Routers'
import CreateNoDeptProjectListRoleRouters from './modules/create-no-dept-project-list-role/CreateNoDeptProjectListRole.Routers'
import CreateDeptProjectPermissionRouters from './modules/create-dept-project-permission/CreateDeptProjectPermission.Routers'

const QuanLyGiaoViecRouters: AppRouterItem[] = [
  {
    path: `${QUAN_LY_GIAO_VIEC_SHORT_PREFIX_URL}/*`,
    element: (
      <Routes>
        {mapRouterHelper(ProjectRouters)}
        {mapRouterHelper(AdminGiaoViecRouters)}
        {mapRouterHelper(TaskFileCategoryRouters)}
        {mapRouterHelper(TaskTagRouters)}
        {mapRouterHelper(CustomFieldRouters)}
        {mapRouterHelper(CreateNoDeptProjectListRoleRouters)}
        {mapRouterHelper(CreateDeptProjectPermissionRouters)}
      </Routes>
    ),
  },
]

export default QuanLyGiaoViecRouters
